import { render, staticRenderFns } from "./ServiceSelectionTable.vue?vue&type=template&id=4b07ddcf&"
import script from "./ServiceSelectionTable.vue?vue&type=script&lang=js&"
export * from "./ServiceSelectionTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b07ddcf')) {
      api.createRecord('4b07ddcf', component.options)
    } else {
      api.reload('4b07ddcf', component.options)
    }
    module.hot.accept("./ServiceSelectionTable.vue?vue&type=template&id=4b07ddcf&", function () {
      api.rerender('4b07ddcf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/components/ServiceSelectionTable.vue"
export default component.exports